import React from 'react';
import { Avatar } from 'components';

function ProfileLink() {
  return <Avatar />;
}

export default ProfileLink;
